// integration with @sentry/react
import { Route as RouteOriginal } from 'react-router-dom';

import * as Sentry from '@sentry/react';
import { createBrowserHistory } from 'history';

export {
  Route as RouteOriginal,
  Router,
  Switch,
  Link,
  useHistory,
  useLocation,
  useParams,
  useRouteMatch,
} from 'react-router-dom';

// Create Custom Sentry Route component
export const Route = Sentry.withSentryRouting(RouteOriginal);

export const history = createBrowserHistory();
